import './ApplicantManageJobs.css'
import { Tag } from 'primereact/tag';
import { useEffect, useState } from 'react';
import { requestGetBoardJobs, requestGetJob } from '../../services/wisdomServices/jobServices';
import { requestApplyToJob, requestGetJobApplicants } from '../../services/wisdomServices/jobApplications';
import { getSessionItem } from '../../utils/helper/session';
import { Carousel } from 'primereact/carousel';
import moment from 'moment/moment';
import { Skeleton } from 'primereact/skeleton';
import ApplicantJobDetails from '../../components/applicantJobDetails/ApplicantJobDetails';
import { Divider } from 'primereact/divider';

function ApplicantManageJobs(){
    const user = getSessionItem("User")
    const [loading, setLoading] = useState(false)
    const [loadingJobDetails, setLoadingJobDetails] = useState(false);
    const [jobs, setJobs] = useState([]);
    const [openJobs, setOpenJobs] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [loadingJobId, setLoadingJobId] = useState(null);
    
    const skeletonTemplate = () => {
        return (
            <div className="applied-job-card">

            {/* HEADER */}
            <div className="applied-job-card-header">
                <Skeleton width="70%" height="16px" className="mb-2" />
                <Skeleton width="50%" height="12px" />
            </div>

            {/* DESCRIPTION */}
            <div className="applied-job-description">
                <Skeleton width="100%" height="12px" className="mb-2" />
                <Skeleton width="80%" height="12px" />
            </div>

            {/* FOOTER */}
            <div className="applied-job-footer">
                <Skeleton width="30%" height="12px" />
                <Skeleton width="60px" height="20px" borderRadius="10px" />
            </div>

            </div>
        );
    };

    const skeletonItems = Array.from({ length: 4 });

    const loadOpenJobs = async() => {
        try {
            const reponse = await requestGetBoardJobs(1, 100, 0, user.id)
            setOpenJobs(reponse.data)
        } catch (error) {
            console.error(`Error: ${error}`)
        }
    }

    const loadJobs = async() => {
        try {
            setLoading(true)
            const pagination = {
                pageNumber: 1,
                pageSize: 1000
            }
            const response = await requestGetJobApplicants(0, user.id, pagination)
            setJobs(response.data)
            
        } catch (error) {
            console.error("Error: ", error)

        } finally {
            setLoading(false)
        }
    }

    const handleOpenJobDetailsDialog = async(job) => {
        if (loadingJobDetails) return
        try {
            const currentJobUuid = job.jobUuid || job.uuid;

            setLoadingJobDetails(true)
            setLoadingJobId(currentJobUuid)

            setSelectedJob(null)
            setOpenDialog(true)

            const jobDetails = await requestGetJob(currentJobUuid)

            const enrichedJob = {
                ...jobDetails,
                jobUuid: currentJobUuid,
                applicationStatus: job.status
            };

            setSelectedJob(enrichedJob)

        } catch (error) {
            console.error(error)
        } finally {
            setLoadingJobDetails(false)
        }
    }

    const responsiveAppliedOptions = [
        {
            breakpoint: "1024px",
            numVisible: 2,
            numScroll: 2
        },
        {
            breakpoint: "768px",
            numVisible: 1,
            numScroll: 1
        }
    ];

    const applyToJob = async (jobUuid, videoUrl, resumeBase64, fileName, applicationExtraFields = {} ) => {
        try {
            await requestApplyToJob(
                jobUuid,
                user.id,
                videoUrl,
                resumeBase64,
                fileName,
                applicationExtraFields
            );

            const appliedJob = openJobs.find(
                j => (j.jobUuid || j.uuid) === jobUuid
            );

            if (appliedJob) {
                const newAppliedJob = {
                    ...appliedJob,
                    status: "Applied",
                    appliedAt: new Date().toISOString()
                };

                setJobs(prev => [newAppliedJob, ...prev]);
                setOpenJobs(prev =>
                    prev.filter(j => (j.jobUuid || j.uuid) !== jobUuid)
                );
            }

        } catch (error) {
            console.error("Error applying to job: ", error)
        }
    };

    const getApplicationStatusName = (status) => {
        if (status === "InInterview") {
            return "In Interview"
        }

        return status
    }

    const appliedJobsTemplate = (job) => {
        const meta = `${job.department} - ${job.location} - ${job.workType}`

        return (
            <div className='applied-job-card' onClick={() => handleOpenJobDetailsDialog(job)}>

                {/* HEADER */}
                <div className='applied-job-card-header'>
                    <h6 
                        className='applied-job-title'
                    >
                        {job.jobTitle}

                        {loadingJobId === job.uuid && (
                            <i className="pi pi-spin pi-spinner" />
                        )}

                    </h6>

                    <span className='applied-job-meta'>
                        {meta}
                    </span>
                </div>

                {/* DESCRIPTION */}
                <div className='applied-job-description'>
                    {job.jobDescription}
                </div>

                {/* FOOTER */}
                <div className='applied-job-footer'>
                    <span className='applied-job-date'>
                        {moment(job.createdAt).fromNow()}
                    </span>
                    {job.status && (
                        <Tag 
                            value={getApplicationStatusName(job.status)}
                            className={`applicant-manage-job-card-status applicant-status-${job.status}`}
                        />
                    )}
                </div>

            </div>
        )
    }


    useEffect(() => {
       const loadData = async () => {
            setLoading(true)
            await Promise.all([
                loadJobs(),
                loadOpenJobs()
            ])
            setLoading(false)
        }

        loadData()
    }, [])

    return(
        <div className='manage-jobs-page'>
            <section>
                <div className="jobs-section-header">
                    <h3>Applied jobs</h3>
                    <span className="jobs-count">{jobs.length}</span>
                </div>
                <div className='applicant-manage-job-carousel-card'>
                    <Carousel 
                        value={loading ? skeletonItems :jobs} 
                        numVisible={4} 
                        responsiveOptions={responsiveAppliedOptions} 
                        itemTemplate={loading ? skeletonTemplate : appliedJobsTemplate}
                        className='applied-jobs-carousel'
                        showIndicators={false}
                    />
                </div>
            </section>

            <Divider />

            <section>
                <div className="jobs-section-header">
                    <h3>Open jobs</h3>
                    <span className="jobs-count jobs-count-open">{openJobs.length}</span>
                </div>
                <div className='applicant-manage-job-carousel-card'>
                    <Carousel 
                        value={loading ? skeletonItems : openJobs} 
                        numVisible={4} 
                        responsiveOptions={responsiveAppliedOptions} 
                        itemTemplate={loading ? skeletonTemplate : appliedJobsTemplate}
                        className='applied-jobs-carousel'
                        showIndicators={false}
                    />
                </div>
            </section>

            {openDialog && (
                <ApplicantJobDetails
                    job={selectedJob}
                    visible={openDialog}
                    onHide={() => setOpenDialog(false)}
                    onApply={applyToJob}
                />
            )}

        </div>
    )

}

export default ApplicantManageJobs;